import React from "react";
import { Helmet } from "react-helmet"; // ✅ Import Helmet

const cardData = [
  { image: "/Fintech 1.svg", title: "Fintech", desc: "We build secure, scalable fintech solutions that power digital payments, banking, and investment platforms." },
  {image: "/Agritech.svg", title: "Agritech", desc: "Designing agriculture-focused websites that showcase farming solutions, crop management, and market access, empowering farmers and agribusinesses." },
  { image: "/Vector (1).svg", title: "Healthcare", desc: "We build innovative healthcare platforms that simplify bookings, manage patient data, and enhance care delivery." },
  { image: "/real_esate.svg", title: "Wellness Management", desc: "We build innovative wellness platforms that simplify bookings, manage patient data, and enhance care delivery." },
  { image: "/drink_15869633 1.svg", title: "Public Sector", desc: "Creating FMCG websites with product showcases, promotional campaigns, and seamless user journeys to drive sales and build brand loyalty." },
  { image: "/media 1.svg", title: "Gaming", desc: "Creating immersive gaming websites that highlight new releases, community features, and interactive experiences to engage players worldwide." },
  //  { image: "/drink_15869633 1.svg", title: "Wellness Management", desc: "Creating FMCG websites with product showcases, promotional campaigns, and seamless user journeys to drive sales and build brand loyalty." },
  
];

function ServedIndustries() {
  return (
     <div className="served-industries-container">
       {/* ✅ SEO Meta Tags */}
      {/* <Helmet>
        <title>Industries We Serve | Pravisht Digital</title>
        <meta name="description" content="Explore how Pravisht serves top industries like fintech, healthcare, gaming, and more with tailored digital solutions." />
        <meta name="keywords" content="Industries, Fintech, Healthcare, Gaming, Agritech, Public Sector, Wellness, Pravisht" />
        <meta property="og:title" content="Industries We Serve | Pravisht Digital" />
        <meta property="og:description" content="From finance to gaming, discover how Pravisht empowers diverse industries with cutting-edge digital technology." />
        <meta property="og:type" content="website" />
        <meta name="author" content="Pravisht Digital" />
      </Helmet> */}
      <h1>Industries We Proudly Serve</h1>
      <hr className="portfolio-horizontalline"></hr>
      <div className="served-industries-grid"> 
        {cardData.map((card, index) => (
          <div key={index} className="served-industries-card">
            {/* <div className="served-industries-icon">{card.icon}</div> */}
             <img src={card.image} alt={card.title} className="served-industries-icon" />
            <h3 className="served-industries-title">{card.title}</h3>
            <p className="served-industries-desc">{card.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ServedIndustries;
